import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "x-transition-slide" }

import { isMobileSafari } from 'mobile-device-detect';
import { computed } from 'vue';


const __default__ = {
  name: 'XTransitionSlide',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disableAnimation: { type: Boolean, required: false, default: false },
  isRouteAnimation: { type: Boolean, required: false, default: false },
  isXs: { type: Boolean, required: true },
  moveBack: { type: Boolean, required: false, default: false },
  push: { type: Boolean, required: false, default: false },
  triggeredByBackBtn: { type: Boolean, required: false, default: false },
},
  emits: ["transition-enter-started", "transition-enter-finished", "transition-finished"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const animation = computed(() => {
  if (!props.isXs || props.disableAnimation) {
    return '';
  }

  // disable animation for route back on mobile safari (to avoid double animation)
  if (isMobileSafari && props.moveBack && props.isRouteAnimation && !props.triggeredByBackBtn) {
    return '';
  }

  if (props.push) {
    return props.moveBack ? 'push-prev' : 'push-next';
  }

  return props.moveBack ? 'prev' : 'next';
});

const onEnter = () => {
  emit('transition-enter-started');
};
const onAfterEnter = () => {
  emit('transition-enter-finished');
};
const onEnterCancelled = () => {
  emit('transition-enter-finished');
};
const onLeave = () => {
  const eventData = {
    detail: {
      goBack: false,
    },
  };

  emit('transition-finished', eventData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: animation.value,
      css: __props.isXs,
      onEnter: onEnter,
      onAfterEnter: onAfterEnter,
      onEnterCancelled: onEnterCancelled,
      onLeave: onLeave
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["name", "css"])
  ]))
}
}

})